import React from 'react';

import { Card } from '@xingternal/card';
import { SkeletonBody } from '@xingternal/skeleton';

import * as S from './job-card-skeleton.styles';

export const JobCardSkeleton: React.FC = () => (
  <Card>
    <S.SkeletonProfileImage />
    <S.SkeletonHeadline amountRows={1} />
    <SkeletonBody amountRows={2} />
  </Card>
);
